export function loadScript(src: string, onload?: any) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;
  script.crossOrigin = 'anonymous';
  document.body.appendChild(script);
  return new Promise<void>((resolve, reject) => {
    script.onload = () => {
      if (typeof onload === 'function') {
        setTimeout(() => {
          resolve(onload());
        });
      } else {
        resolve();
      }
    };
    script.onerror = (error) => {
      reject(error);
    };
  });
}
